export default __webpack_public_path__ + "static/media/7.beb32b08.png";